﻿import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import TKButtonDropdown from '@tk/controls/tk.button.dropdown';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKHeader from '@tk/components/tk.header';
import TKViewport from '@tk/basics/tk.viewport';
import TKSearch from '@tk/controls/tk.search';
import TKBasketButton from '@tk/components/tk.basket.button';
import TKCarousel from '@tk/components/tk.carousel';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKMinibasket from '@tk/components/tk.minibasket';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import TKDialog from '@tk/components/tk.dialog';
import TKPrice from '@tk/components/tk.price';
import TKStock from '@tk/components/tk.stock';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKTabsTab from '@tk/controls/tk.tabs.tab';
import TKArticleList from '@tk/components/tk.article.list';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKAssetGallery from '@tk/components/tk.asset.gallery';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKSelection from '@tk/controls/tk.selection';
import TKArtSpecTable from '@tk/components/tk.art.spec.table';
import TKShowMore from '@tk/components/tk.show.more';
import TKSelectRedirect from '@tk/controls/tk.select.redirect';
import TKPopup from '@tk/components/tk.popup';
import TKArticleListSort from '@tk/components/tk.article.list.sort';
import TKArticleListLayoutSwitch from '@tk/components/tk.article.list.layout.switch';
import TKBreadcrumb from '@tk/components/tk.breadcrumb';
import TKCompareButton from '@tk/components/compare/tk.compare.button';
import TKCompareStore from '@tk/components/compare/tk.compare.store';
import TKCompareInfo from '@tk/components/compare/tk.compare.info';
import TKFormDatepicker from '@tk/controls/tk.form.datepicker';
import TKFormTimepicker from '@tk/controls/tk.form.timepicker';
import TCSectionToggler from '@/components/tc.section.toggler';
import { configureStore } from '@tk/utilities/tk.use.store';
import TCProductSelect from '@/components/productselect/tc.product.select';
import TCCounterpartDevices from '@/components/productselect/tc.product.select.counterpart.devices';
import TCRemoteDevices from '@/components/productselect/tc.product.select.remote.devices';
import TCGridCollection from '@/components/productselect/tc.product.select.grid.collection';
import TCProductSelectStore from '@/components/productselect/tc.product.select.store';
import TCDeviceQuantityCounter from '@/components/productselect/tc.device.quantity.counter';
import TCSubmitDirect from '@/controls/tc.submit.direct';
import TCArtSpecTable from '@/components/tc.art.spec.table';
import TCSelectRedirect from '@/components/tc.select.redirect';
import TCSpareDialog from './components/tc.spare.dialog';
import TKFileUploadArea from '@tk/controls/tk.file.upload.area';

import 'tippy.js/dist/tippy.css';
import '@splidejs/splide/dist/css/splide.min.css';
import 'flatpickr/dist/flatpickr.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@uppy/core/dist/style.min.css';
import '@scss/modules/article.scss';


const compareStore = new TKCompareStore();
const productSelectStore = new TCProductSelectStore();

configureStore({
    productSelectStore,
    compareStore,
});

export default class Article extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-button-dropdown', constructor: TKButtonDropdown },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'tk-search', constructor: TKSearch },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-carousel', constructor: TKCarousel },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-minibasket', constructor: TKMinibasket },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-article-list', constructor: TKArticleList },
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-stock', constructor: TKStock },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-tabs-tab', constructor: TKTabsTab },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-asset-gallery', constructor: TKAssetGallery },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-art-spec-table', constructor: TKArtSpecTable },
            { name: 'tc-art-spec-table', constructor: TCArtSpecTable },
            { name: 'tk-show-more', constructor: TKShowMore },
            { name: 'tk-select-redirect', constructor: TKSelectRedirect },
            { name: 'tk-popup', constructor: TKPopup },
            { name: 'tk-article-list-sort', constructor: TKArticleListSort },
            { name: 'tk-article-list-layout-switch', constructor: TKArticleListLayoutSwitch },
            { name: 'tk-breadcrumb', constructor: TKBreadcrumb },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-compare-info', constructor: TKCompareInfo },
            { name: 'tc-product-select', constructor: TCProductSelect },
            { name: 'tc-counterpart-devices', constructor: TCCounterpartDevices },
            { name: 'tc-remote-devices', constructor: TCRemoteDevices },
            { name: 'tc-grid-collection', constructor: TCGridCollection },
            { name: 'tc-device-quantity-counter', constructor: TCDeviceQuantityCounter },
            { name: 'tk-form-datepicker', constructor: TKFormDatepicker },
            { name: 'tk-form-timepicker', constructor: TKFormTimepicker },
            { name: 'tc-submit-direct', constructor: TCSubmitDirect },
            { name: 'tc-select-redirect', constructor: TCSelectRedirect },
            { name: 'tc-section-toggler', constructor: TCSectionToggler },
            { name: 'tc-spare-dialog', constructor: TCSpareDialog },
            { name: 'tk-file-upload-area', constructor: TKFileUploadArea },
        ]);
    }
}

new Article();
